import { StyleSheet } from "react-native"
import { colors, typography } from "theme"

export const style = StyleSheet.create({
  button: { marginBottom: 20 },
  buttonContainer: { flex: 1, justifyContent: "flex-end", marginBottom: 50 },
  cell: {
    alignSelf: "center",
    borderColor: colors.inputFieldBorder,
    borderRadius: 10,
    borderWidth: 1,
    fontSize: 24,
    height: 40,
    justifyContent: "center",
    marginRight: 20,
    paddingTop: 5,
    textAlign: "center",
    width: 40,
  },
  container: { height: "100%", marginHorizontal: 10 },

  disabledButton: {
    opacity: 0.5,
  },
  focusCell: {
    borderColor: colors.linearFirstColor,
  },
  mt10: { marginTop: 10 },
  otpContainer: { justifyContent: "flex-start", marginVertical: 20 },
  rootStyle: { justifyContent: "flex-start", marginBottom: 10 },

  titleText: {
    fontFamily: typography.primary.normal,
    fontSize: 23,
    marginBottom: 10,
    marginTop: 10,
  },
})
